import { render, staticRenderFns } from "./bianmin.vue?vue&type=template&id=17be99ae&scoped=true"
import script from "./bianmin.vue?vue&type=script&lang=js"
export * from "./bianmin.vue?vue&type=script&lang=js"
import style0 from "./bianmin.vue?vue&type=style&index=0&id=17be99ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be99ae",
  null
  
)

export default component.exports